import { cva } from "class-variance-authority";

const stylesBgPrimary = cva("absolute top-0 right-0 w-[8px] h-[8px] rounded-full", {
  variants: {
    mode: {
      light: "bg-light-primary",
      dark: "bg-dark-primary"
    }
  }
});

const stylesBg = cva(
  "items-center right-0 flex flex-col flex-nowrap rounded-[16px] pt-[12px] shadow-[0_2px_20px_rgba(0,0,0,.12)]",
  {
    variants: {
      mode: {
        light: "bg-light-background",
        dark: "bg-dark-fill-secondary backdrop-blur-[15px]"
      }
    }
  }
);

const stylesLink = cva("", {
  variants: {
    mode: {
      light: "text-light-label hover:text-light-primary",
      dark: "text-dark-label hover:text-dark-primary"
    }
  }
});

export { stylesBg, stylesBgPrimary, stylesLink };
